import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useResponsive } from '~/client-flow/contexts';
import { ClientOnboardingContentDesktop } from './ClientOnboardingContentDesktop';
import { ClientOnboardingContentMobile } from './ClientOnboardingContentMobile';
export const ClientOnboardingContent = (props)=>{
    const { isMobile } = useResponsive();
    if (isMobile) {
        return /*#__PURE__*/ _jsx(ClientOnboardingContentMobile, _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsx(ClientOnboardingContentDesktop, _object_spread({}, props));
};
